import { observer } from 'mobx-react'
import React from 'react'
import { Helmet } from 'react-helmet'
import { AppStyles } from './app.style'
import { withStyles, WithStyles } from '@material-ui/styles'
import favIcon from '../../favicons/favicon.ico'
import webManifest from '../../favicons/site.webmanifest'
import { contentStore } from 'stores/contentStore/contentStore'
import { topBarStore } from 'stores/topBarStore'

type DefaultProps = WithStyles<typeof AppStyles>

@observer
class Default extends React.Component<DefaultProps> {
  componentDidMount() {
    topBarStore.setVisibility(false)
  }

  render() {
    let seoDescription = ''
    let seoTitle = ''
    if (contentStore.uiElements && contentStore.uiElements) {
      seoDescription = contentStore.uiElements.SEODescription
      seoTitle = contentStore.uiElements.SEOTitle
    }

    return (
      <React.Fragment>
        <Helmet>
          <link rel="shortcut icon" href={favIcon} />
          <link rel="manifest" id="manifest" href={webManifest} />
          <title>{seoTitle}</title>
          <meta name="description" content={seoDescription} />
        </Helmet>
      </React.Fragment>
    )
  }
}

export default withStyles(AppStyles)(Default)
